import * as React from 'react'
import { styled } from '@mui/material/styles'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import DoneIcon from '@mui/icons-material/Done'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}))

const categoriesImport = [
    { key: 'language', label: 'Language' },
    { key: 'display', label: 'Display' },
    { key: 'graph', label: 'Graph Processing' },
    { key: 'processing', label: 'Text Processing' },
    { key: 'stopwords', label: 'Stopwords' },
    { key: 'synonyms', label: 'Synonyms' },
    // { key: 'voice', label: 'Voice Input' },
    { key: 'branding', label: 'Custom Branding' },
    { key: 'midi', label: 'Midi & Sound' },
]

export default function FilterChips({ preselectedChip, onClick }) {
    const [selectedChip, setSelectedChip] = React.useState(preselectedChip)

    const isMobile = useMediaQuery('(max-width:600px)')

    React.useEffect(() => {
        setSelectedChip(preselectedChip)
    }, [preselectedChip])

    return (
        <Box
            component="ul"
            sx={{
                display: 'flex',
                listStyle: 'none',
                px: 0,
                pt: 0,
                pl: 0,
                ml: -0.5,
                flexWrap: 'wrap',
            }}
        >
            <Box
                sx={{
                    pt: 0,
                    pb: 0,
                }}
            >
                <Typography
                    component="h6"
                    variant="h6"
                    align="left"
                    color="text.primary"
                    sx={{
                        pl: 0.5,
                    }}
                >
                    {' '}
                </Typography>
            </Box>
            <Box
                sx={{
                    backgroundColor: theme => theme.palette.background.default,
                    display: 'flex',
                    listStyle: 'none',
                    px: 0,
                    flexWrap: 'wrap',
                    ml: 0,
                    pt: 0,
                    pl: 0,
                }}
            >
                {categoriesImport.map(category => {
                    const onChipClick =
                        selectedChip === category.key
                            ? null
                            : () => {
                                  onClick(category.key)
                                  setSelectedChip(category.key)
                              }

                    return (
                        <ListItem key={category.key}>
                            <Chip
                                label={category.label}
                                color={
                                    selectedChip === category.key
                                        ? 'primary'
                                        : 'default'
                                }
                                sx={{
                                    fontSize: isMobile ? '0.8rem' : '1rem',
                                    fontWeight: '600',
                                    height: isMobile
                                        ? theme => theme.spacing(3)
                                        : theme => theme.spacing(4.5),
                                    paddingLeft: isMobile
                                        ? theme => theme.spacing(0.5)
                                        : theme => theme.spacing(1.5),
                                    paddingRight: isMobile
                                        ? theme => theme.spacing(0.5)
                                        : theme => theme.spacing(1.5),
                                }}
                                onClick={onChipClick}
                            />
                        </ListItem>
                    )
                })}
            </Box>
        </Box>
    )
}
